import React from "react";
import LandingTypography from "../../landingPage/components/LandingTypography";
import Ticker from "../StockPageHeader/components/Ticker";
import StockName from "../StockPageHeader/components/StockName";
import StockChange from "../StockPageHeader/components/StockChange/StockChange";

function StockBasicDataSummary({
  market,
  ticker,
  change,
  changeValue,
  close,
  latest_quote_datetime_utc,
  currency,
  short_name
}) {
  return (
    <LandingTypography className={"flex gap-2 justify-between shrink-0"}>
      <div className={"flex flex-col gap-1"}>
        {ticker && market ? <Ticker ticker={ticker} market={market} /> : null}
        {short_name ? <StockName name={short_name} /> : null}
      </div>
      {currency && change && close && latest_quote_datetime_utc ? (
        <StockChange
          change={change}
          changeValue={changeValue}
          close={close}
          currency={currency}
          latestQuoteDatetimeUtc={latest_quote_datetime_utc}
        />
      ) : null}
    </LandingTypography>
  );
}

export default StockBasicDataSummary;
